
require.register("xtend/immutable.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "xtend");
  (function() {
    module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}
  })();
});